const LOOPBACK_HOSTS = new Set(['127.0.0.1', 'localhost', '[::1]'])

/**
 * Browser authentication uses HttpOnly same-origin cookies, so the WebSocket
 * upgrade must always stay on the page origin. Non-browser clients may still
 * supply a configured endpoint and use their own ticket transport.
 */
export function resolveClientWsUrl(configuredUrl, locationLike = globalThis.location) {
  const host = locationLike?.host
  if (!host) return configuredUrl

  const protocol = locationLike.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${protocol}//${host}/ws`
}

/**
 * Asset URLs normally arrive in the initial world snapshot. A loopback
 * operator session must keep them on the tunnel instead of escaping to the
 * Basic-Auth protected public hostname.
 */
export function resolveClientAssetsUrl(locationLike = globalThis.location) {
  const hostname = locationLike?.hostname?.toLowerCase()
  const host = locationLike?.host

  if (!LOOPBACK_HOSTS.has(hostname) || !host) {
    return null
  }

  const protocol = locationLike.protocol === 'https:' ? 'https:' : 'http:'
  return `${protocol}//${host}/assets`
}
